module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/tiers/tiers.component.css
// module id = ./src/app/tiers/tiers.component.css
// module chunks = main